<script setup>
import { computed } from 'vue'

import { useDetectDevice } from '@/composables/device'
import { useExpenseClaimActions } from '@/composables/expense-claim'

import ExpenseClaimDetail from '@/components/accounting/ExpenseClaimDetail.vue'
import ExpenseClaimEdit from '@/components/accounting/ExpenseClaimEdit.vue'

const props = defineProps({
  claim: {
    type: Object,
    default: null,
  },
  preselectedRowIds: {
    type: Array,
    default: () => [],
  },
  projectId: {
    type: Number,
    default: null,
  },
})

const emit = defineEmits(['saved', 'changed', 'cancel'])

const { isMobile } = useDetectDevice()
const { canEdit } = useExpenseClaimActions()

const isEditable = computed(() => props.claim !== null && (!props.claim.id || canEdit(props.claim)))
</script>

<template>
  <q-dialog
    :model-value="props.claim !== null"
    class="dialog-lg"
    :maximized="isMobile"
    persistent
  >
    <expense-claim-edit
      v-if="isEditable"
      :model-value="props.claim"
      :preselected-row-ids="props.preselectedRowIds"
      :project-id="props.projectId"
      @update="saved => emit('saved', saved)"
      @cancel="emit('cancel')"
    />
    <expense-claim-detail
      v-else-if="props.claim !== null"
      :model-value="props.claim"
      @update="emit('changed')"
      @cancel="emit('cancel')"
    />
  </q-dialog>
</template>
